<template>
<div id="content">
<!-- ページ内ヘッダ -->
	<div class="center">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>基本情報</li>
			<li class="selected">連絡先</li>
			<li>その他</li>
			<li>内容確認</li>
		</ul>
	</div>
<!-- 内容 -->
	<div id="mosikomi" class="content-blk">
		<Form v-slot="{ errors }" @submit="onSubmit">
			<!-- ステップ２：連絡先 -->
			<div class="inner">
				<dl>
					<dt class="necessary detail_title">郵便番号</dt>
					<dd class="zipcode">〒<Field type="number" name="zipcode1" :rules="isNum3" v-model="katudo.zipcode1" />-<Field type="number" name="zipcode2" :rules="isNum4" v-model="katudo.zipcode2" /></dd>
					<dd class="hinttext">（半角数字3桁と4桁で入力してください/例：【030】-【0801】）</dd>
					<dd class="error" v-if="errors.zipcode1">左側：{{ errors.zipcode1 }}</dd>
					<dd class="error" v-if="errors.zipcode2">右側：{{ errors.zipcode2 }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">住所</dt>
					<dd><Field name="address" :rules="isAddress" v-model="katudo.address"/></dd>
					<dd class="hinttext">（120文字以内/例：【青森市本町4-1-3】）<br>※青森県内の方は市町村名から入力して下さい。青森県外の方は都道府県名から入力して下さい。</dd>
					<dd class="error">{{ errors.address }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">電話番号</dt>
					<dd><Field name="tel" :rules="isTel" v-model="katudo.tel"/></dd>
					<dd class="hinttext">（例：【017-000-0000】【0170000000】）<br>※固定電話がない場合は、携帯電話番号を入力して下さい。</dd>
					<dd class="error">{{ errors.tel }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">携帯電話番号</dt>
					<dd><Field name="phone" :rules="isFax" v-model="katudo.phone"/></dd>
					<dd class="hinttext">（例：【000-0000-0000】【22222222222】）</dd>
					<dd class="error">{{ errors.phone }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">FAX</dt>
					<dd><Field name="fax" :rules="isFax" v-model="katudo.fax"/></dd>
					<dd class="hinttext">（例：【017-000-0000】【3333333333】）</dd>
					<dd class="error">{{ errors.fax }}</dd>
				</dl>
				<dl>
					<dt class="detail_title">メールアドレス</dt>
					<dd><Field name="email" v-model="katudo.mail" :rules="isMail" /></dd>
					<dd class="hinttext">（半角英数字240字以内/例：【info@aomoricity-shakyo.or.jp】）</dd>
					<dd class="error">{{ errors.email }}</dd>
				</dl>
			</div>
	<div class="button_rev justifycont-c">
		<button type="submit" class="btn_on order2">次へ</button>
		<router-link to="/katudo-touroku/step1" class="order1"><button class="btn_cancel">戻る</button></router-link>
	</div>
	<p v-if="Object.keys(errors).length" class="error" style="text-align: center;">未入力もしくはエラー項目があります。ご確認ください。</p>
		</Form>
	</div>
</div>
</template>

<script>
// 状態管理
import { inject } from 'vue';
import { Field, Form } from 'vee-validate';
import router from '../router';
export default {
	name: 'KatsudoTouroku3',
	components: {
		Field,
		Form,
	},
	setup(){
		const { katudo } = inject('ktouroku');
		return {
			katudo,
		};
	},
	data() {
		return {
			// katudo: {},
		};
	},
	methods: {
		onSubmit() {
			router.push({ path: '/katudo-touroku/step3'});
		},
		// バリデーションルール
		// 必須
		isRequired(value) {
			return (value && value.length) ? true : '必須項目です';
		},
		// 25文字以内（必須）
		isName(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (value.length > 25) {
				return '25文字以内で入力してください。'
			}
			return true;
		},
		// 120文字以内（必須）のバリデーション
		isAddress(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (value.length > 120) {
				return '120文字以内で入力してください。'
			}
			return true;
			// return (/^\w{1,120}$/.test(value)) ? true : '120文字以内で入力してください。'
		},
		// 郵便番号（必須）
		isNum3(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (!(/^\d{3}$/.test(value))) {
				return '半角数字3桁で入力してください';
			}
			return true;
		},
		isNum4(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (!(/^\d{4}$/.test(value))) {
				return '半角数字4桁で入力してください';
			}
			return true;
		},
		// 電話番号（必須）のバリデーション
		isTel(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (value.length > 15) {
				return '15文字以内で入力してください。';
			}
			return true;
			// return (/^\d{11}$/.test(value)) ? true : '11桁の半角数字を入力してください。'
		},
		// FAXのバリデーション
		isFax(value) {
			if(!value) {
				return true;
			} else {
				return (value.length > 15) ? '15文字以内で入力してください。' : true
			}
		},
		// メールのバリデーション
		isMail(value) {
			if(!value) {
				return true;
			} else {
				if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))) {
					return 'メールの形式ではありません。';
				}
				if (value.length > 240) {
					return '240文字以内で入力してください。';
				}
				return true;
			}
		},
	},
}
</script>
